"use client";
import "./chunk-M66XENHI.js";
class SessionStorage {
  constructor() {
    this.get = (key) => {
      if (typeof window !== "undefined") {
        return sessionStorage.getItem(key) || null;
      }
      return null;
    };
    this.set = (key, value) => {
      if (typeof window !== "undefined") {
        sessionStorage.setItem(key, value);
      }
    };
    this.removeItem = (key) => {
      if (typeof window !== "undefined") {
        sessionStorage.removeItem(key);
      }
    };
    this.clear = (prefix) => {
      if (typeof window !== "undefined") {
        for (let i = 0; i < sessionStorage.length; i++) {
          const key = sessionStorage.key(i);
          if (key && key.startsWith(prefix)) {
            sessionStorage.removeItem(key);
            i--;
          }
        }
      }
    };
  }
}
export {
  SessionStorage
};
